__turbopack_context__.v({
  "fieldset": "QuestionForm-module__4RNjfq__fieldset",
  "question": "QuestionForm-module__4RNjfq__question",
  "submitButton": "QuestionForm-module__4RNjfq__submitButton",
});
